import {USERTYPE_ANONYMOUS} from 'aa/vue/constants/shared';

export default class ViewTrackingService {
  constructor() {
    this.defaultParams = {
      sitePrimaryRsid: "cbsicbscomsite",
      siteType: "responsive web",
      deviceType: "desktop",
      pageViewGuid: window.__page_uuid || "",
      userType: CBS.Registry.user.sub_status || USERTYPE_ANONYMOUS,
      userId: CBS.Registry.user.id || "",
      pageName: "",
      siteSection: "",
      siteHier: "",
      pageType: ""
    }
  }

  /**
   * Generic view tracking
   * @param {Object} params
   */
  trackView(params) {
    params = Object.assign(this.defaultParams, params)

    CBS.Promises.Tracking.onLoad(() => om.trackView(params))
  }

  /**
   * Generic view tracking
   * @param {Object} params
   */
  trackState(params) {
    params = Object.assign(this.defaultParams, params)

    CBS.Promises.Tracking.onLoad(() => om.trackState(params))
  }

  /**
   * Generic view tracking
   * @param name
   * @param {Object} params
   */
  trackAction(name, params) {
    params = Object.assign(this.defaultParams, params)

    CBS.Promises.Tracking.onLoad(() => om.trackAction(name, params))
  }

  /**
   * Generic trackOverlayView tracking
   * @param {Object} params
   */
  trackOverlayView(params) {
    params = Object.assign(this.defaultParams, params)
    CBS.Promises.Tracking.onLoad(() => om.trackOverlayView(params))
  }

  /**
   * Generic trackOverlayView tracking
   * @param {Object} params
   */
  trackClick(params) {
    params = Object.assign(this.defaultParams, params)
    CBS.Promises.Tracking.onLoad(() => om.trackClick(params))
  }
}
